import React from 'react';
import { Dialog } from 'primereact/dialog';
import { X } from 'lucide-react';

const CustomDialog = ({
  visible,
  onHide,
  header = 'Dialog',
  children,
  width = '600px',
  closable = true,
  contentStyle,
  style,
  ...restProps
}) => {
  return (
    <Dialog
      header={
        (header || closable) ? (
          <div className="flex justify-between items-center bg-white text-lg font-bold text-gray-900 px-6 py-5 border-b border-gray-100">
            <span>{header}</span>
            {closable && (
              <button
                onClick={onHide}
                className="text-gray-500 hover:text-gray-800 bg-gray-50 hover:bg-gray-100 p-1.5 rounded-lg border border-gray-200 transition-colors"
                aria-label="Close"
                type="button"
              >
                <X className="w-5 h-5" />
              </button>
            )}
          </div>
        ) : null
      }
      visible={visible}
      style={{ width, maxHeight: '90vh', borderRadius: '12px', overflow: 'hidden', ...style }}
      onHide={onHide}
      modal
      closable={false} // hide default close button
      draggable={false}
      className="rounded-xl shadow-2xl border-none"
      contentStyle={{ padding: '0', backgroundColor: '#ffffff', maxHeight: 'calc(90vh - 80px)', overflowY: 'auto', ...contentStyle }}
      {...restProps}
    >
      <div className="text-gray-700 text-sm leading-relaxed px-6 py-5 font-medium">{children}</div>
    </Dialog>
  );
};

export default CustomDialog;
 